import React from 'react';
import styled from '@emotion/styled';
import moment from 'moment';

import ReactCalendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '~Assets/Css/custom-calendar-styles.css';
import navigateLeftIcon from '~/Assets/icons//navigate-left.svg';
import navigateRightIcon from '~/Assets/icons//navigate-right.svg';

import { useSelector } from '~Hooks';

const Wrapper = styled.div`
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  background-color: #fff;
  padding: 16px;
  width: 360px;
  margin-bottom: 16px;
  color: #000;
`;

const DateNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
  margin-top: 8px;
`;

const DateText = styled.span`
  font-weight: 600;
  margin-bottom: 4px;
  font-size: 20px;
`;

const Prev = styled.div`
  width: 48px;
  height: 48px;
  mask-image: url('${navigateLeftIcon}');
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #3a3a3a;
  margin-right: 12px;
`;

const Next = styled.div`
  width: 48px;
  height: 48px;
  mask-image: url('${navigateRightIcon}');
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #3a3a3a;
  margin-left: 12px;
`;

interface Props {
  onChange: (date: Date) => void;
  value: Date;
  maxDate: Date;
}

const Calendar = ({ onChange, value, maxDate }: Props) => {
  const language = useSelector((state) => state.language);
  let lang: string = language;
  if (language == 'se') lang = 'sv';

  const previousDate = () => {
    const prev = moment(value).subtract(1, 'day');
    onChange(prev.toDate());
  };

  const nextDate = () => {
    if (moment(value).isSame(moment(), 'day')) return;

    const next = moment(value).add(1, 'day');
    onChange(next.toDate());
  };

  return (
    <Wrapper>
      <ReactCalendar
        onChange={(date: any) => onChange(date)}
        value={value}
        locale={lang}
        maxDate={maxDate}
      />
      <DateNav>
        <Prev onTouchStart={previousDate} />
        <DateText>{moment(value).format('YYYY-MM-DD')}</DateText>
        <Next onTouchStart={nextDate} />
      </DateNav>
    </Wrapper>
  );
};

export default Calendar;
